var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomInstitution = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0V0z",
    id: "7yqkh9anaa"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#7yqkh9anaa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 4h20v20H5z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#BFBFBF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.637 20.986H6.923a.793.793 0 0 0-.788.788c0 .432.356.789.788.789h15.714a.793.793 0 0 0 .789-.789.793.793 0 0 0-.789-.788zM7.906 18.945a.793.793 0 0 0-.788.788c0 .432.356.789.788.789h13.748a.793.793 0 0 0 .789-.789.793.793 0 0 0-.789-.788h-.194V11.87h.194a.387.387 0 0 0 .39-.389.387.387 0 0 0-.39-.389H7.906a.387.387 0 0 0-.389.389c0 .216.173.389.389.389H8.1v7.074h-.194zm11.977-7.074v7.074H17.53V11.87h2.354zm-3.931 0v7.074h-2.354V11.87h2.354zm-6.286 0h2.355v7.074H9.666V11.87zM6.923 10.38h15.725a.793.793 0 0 0 .788-.788.797.797 0 0 0-.529-.745l-7.797-3.51a.756.756 0 0 0-.648 0L6.599 8.868a.78.78 0 0 0-.443.886.776.776 0 0 0 .767.626z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomInstitution);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-institution.e4146469fac3b5c1ea384dafd5c55856.svg";